module.exports = __webpack_public_path__ + "03_mole.8753ec51.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer2/03_mole.png
// module id = J9NJ
// module chunks = 0